import { useTranslation } from 'react-i18next'
import { useQueryParams } from 'use-query-params'

import { ReactComponent as Refresh } from '../../../../../assets/icons/refresh.svg'
import { MessagesFiltersCategoriesEnum } from '../MessagesFilters'

import { joinClassNames } from '../../../../../utils/styles'
import styles from './messages-filters-menu.module.scss'

interface IMessageFiltersMenu {
    category: MessagesFiltersCategoriesEnum
    setCategory: React.Dispatch<
        React.SetStateAction<MessagesFiltersCategoriesEnum>
    >
}

function MessagesFiltersMenu(props: IMessageFiltersMenu) {
    const { category, setCategory } = props

    const { t } = useTranslation()

    const [, setQuery] = useQueryParams()

    return (
        <div className={styles.messagesFiltersMenu}>
            <div>
                {Object.keys(MessagesFiltersCategoriesEnum).map((key) => {
                    const messagesFilterKey =
                        key as keyof typeof MessagesFiltersCategoriesEnum

                    const messagesCategory =
                        MessagesFiltersCategoriesEnum[messagesFilterKey]

                    return (
                        <button
                            className={joinClassNames(
                                styles.messagesFiltersMenu__btn,
                                category === messagesCategory &&
                                    styles.messagesFiltersMenu__btnActive
                            )}
                            onClick={() => setCategory(messagesCategory)}
                            key={key}
                        >
                            {t(messagesCategory)}
                        </button>
                    )
                })}
            </div>
            <button
                onClick={() => setQuery({}, 'replace')}
                className={styles.messagesFiltersMenu__clearBtn}
            >
                <Refresh className={styles.messagesFiltersMenu__clearBtnIcon} />
            </button>
        </div>
    )
}

export default MessagesFiltersMenu
